import React, { useEffect, useState } from "react";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
// import logo from "../../resources/img/login.jpg";
// import login from "../resources/img/login.jpg"
//eslint-disable-next-line
// import sidebarlogo from "../../resources/img/homelogo.png";
// import sidebarlogo from "/sidebarlogo.png";

const PaymentDepositPDF = (props) => {
  //eslint-disable-next-line
  const [invoiceRec, setInvoiceRec] = useState(
    props.clientInvoiceData ? props.clientInvoiceData : {}
  );
  const [imageData, setImageData] = useState("");
  const [partyData, setPartyData] = useState({});
  const [challanData, setChallanData] = useState({});
  const [advanceAmountData, setAdvanceAmount] = useState({});

  useEffect(() => {
    if (props?.clientInvoiceData?.id) {
      initinvoiceRec();
    }
    //eslint-disable-next-line
  }, [props.refresh]);
  async function initinvoiceRec() {
    const result = await trasportApi.fetchClientInvoiceById(
      props.clientInvoiceData?.id || ""
    );
    setInvoiceRec(result || {});

    if (result?.client_id) {
      const party = await trasportApi.fetchAllClientById(result.client_id);
      setPartyData(party || {});

      const challan = await trasportApi.fetchByClientIdOnPDf(result.client_id);
      setChallanData(challan || []); // Default to an empty array
    }
  }

  console.log("invoiceRec Pdf", challanData);
  //   const urlContentToDataUri = (url) => {
  //     return fetch(url)
  //       .then((response) => response.blob())
  //       .then(
  //         (blob) =>
  //           new Promise((callback) => {
  //             let reader = new FileReader();
  //             reader.onload = function () {
  //               callback(this.result);
  //             };
  //             reader.readAsDataURL(blob);
  //           })
  //       );
  //   };

  function numberToWords(num) {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (num === 0) return "Zero";

    if (num < 10) return units[num];
    if (num < 20) return teens[num - 10];
    if (num < 100)
      return (
        tens[Math.floor(num / 10)] +
        (num % 10 !== 0 ? " " + units[num % 10] : "")
      );

    if (num < 1000) {
      return (
        units[Math.floor(num / 100)] +
        " Hundred" +
        (num % 100 !== 0 ? " and " + numberToWords(num % 100) : "")
      );
    }

    if (num < 1000000) {
      return (
        numberToWords(Math.floor(num / 1000)) +
        " Thousand" +
        (num % 1000 !== 0 ? " " + numberToWords(num % 1000) : "")
      );
    }

    if (num < 1000000000) {
      return (
        numberToWords(Math.floor(num / 1000000)) +
        " Million" +
        (num % 1000000 !== 0 ? " " + numberToWords(num % 1000000) : "")
      );
    }

    return "Number too large";
  }

  const totalDispatchWeight = Array.isArray(challanData)
    ? challanData.reduce((sum, item) => {
        const dispatchWeight = parseFloat(item?.actual_total_freight || 0); // Safe navigation and default to 0
        return !isNaN(dispatchWeight) ? sum + dispatchWeight : sum;
      }, 0)
    : 0; // Default to 0 if challanData is not an array

  // const totalAmount = Math.floor(props.clientInvoiceData.total_invoice_amount).toLocaleString();
  //   const paidamount = Math.floor(props.clientInvoiceData.amount).toLocaleString();

  const headers = [
    "Sr.",
    "Date",
    "LR.No",
    "Vehicle No.",
    "From",
    "To",
    "Rate",
    "Qty (M.T.)",
    "Advance",
    "Balance",
    "Unloading",
  ];

  const headerStyle = {
    border: "1px solid black",
    padding: "5px",
    textAlign: "left",
  };

  const calculateGST = () => {
    // Extract the first two characters of GST number
    const gstStart = partyData.gst_no?.substring(0, 2);

    // Check if it starts with "08"
    if (gstStart === "08") {
      // Calculate 12% GST
      const gstAmount = invoiceRec.total_invoice_amount
        ? (invoiceRec.total_invoice_amount * 12) / 100
        : 0;
      return gstAmount;
    } else {
      // Calculate 6% GST if not "08"
      const gstAmount = invoiceRec.total_invoice_amount
        ? (invoiceRec.total_invoice_amount * 6) / 100
        : 0;
      return gstAmount;
    }
    return 0; // Return 0 if GST is not applicable
  };

  const gstAmount = calculateGST();
  const totalWithGST = gstAmount
    ? parseFloat(invoiceRec.total_invoice_amount) + parseFloat(gstAmount)
    : parseFloat(invoiceRec.total_invoice_amount);

  // Round off the total amount
  const roundedTotal = Math.round(totalWithGST);
  const formattedTotal = roundedTotal.toLocaleString("en-IN");


  // const totalAmountInWords = numberToWords(formattedTotal);
  const totalAmountInWords = numberToWords(Math.round(roundedTotal));

  return (
    <div className="flex justify-center" style={{ fontSize: "10px" }}>
      <div style={{ margin: "20px auto", maxWidth: "800px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid black",
            marginBottom: "10px",
          }}
        >
          <tbody>
            <tr>
              <td
                colSpan={2}
                style={{ border: "1px solid black", padding: "5px" }}
              >
                GST NO. 08CBUPK4718E2ZB | PAN NO. : CBUPK4718E
              </td>
              <td style={{ border: "1px solid black", padding: "5px" }}>
                HSN CODE : 996519
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style={{
            width: "100%",
            backgroundColor: "",
            border: "1px solid black",
            textAlign: "center",
            margin: 0,
            padding: "10px",
          }}
        >
          <tbody>
            <tr>
              <td colSpan="2">
                <h2 style={{ margin: 0 }}>G N CARGO TRANSWAYS.</h2>
              </td>
            </tr>
            <tr>
              <td colSpan="2">AJMER - RAJASTHAN INDIA</td>
            </tr>
            <tr>
              <td colSpan="2" style={{ textAlign: "center", margin: "5px 0" }}>
                Phone: 9982365644 / 9414115644
                <br />
                Email: gncargotransways@gmail.com
              </td>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "10px",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  width: "60%",
                  border: "1px solid black",
                  padding: "5px",
                }}
              >
                To,
                <br />
                {partyData.client_name}
                <br />
                {partyData.address}
                <br />
                {partyData.city} {partyData.state}
                <br />
                Pin code :- {partyData.pincode} <br />
                GST NO :- {partyData.gst_no}
              </td>
              <td
                style={{
                  width: "40%",
                  border: "1px solid black",
                  padding: "5px",
                }}
              >
                Bill No : {invoiceRec.invoice_number}
                <br />
                Date : {moment(invoiceRec.invoice_date).format("DD-MMMM-YYYY")}
                <br />
                Mode of Transport: Road
                <br />
                SAC Description: Transport by Road
                <br />
                Material Trans: {props.clientInvoiceData.item_name}
              </td>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: "90%",
            borderCollapse: "collapse",
            marginTop: "10px",
            alignContent: "center",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Sr.
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Date
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                LR.No
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Vehicle No.
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                From
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                To
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Rate
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Qty (M.T.)
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Unloading Amount
              </th>
              <th
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  textAlign: "left",
                }}
              >
                Balance
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(challanData) &&
              challanData.map((item, index) => (
                <tr key={item.id || index}>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {index + 1}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {new Date(item.challan_date).toLocaleDateString()}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.g_r_no}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.vehicle_number}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.from_station_id}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.to_station_id}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.actual_item_rate}
                  </td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.dispatch_weight}
                  </td>

                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.advance_amount}
                  </td>

                  <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.actual_total_freight}
                  </td>
                  {/* <td style={{ border: "1px solid black", padding: "5px" }}>
                    {item.g_r_no}
                  </td> */}
                </tr>
              ))}
            {/* Footer rows for totals */}
            <tr>
              <td
                colSpan={6}
                style={{ border: "1px solid black", padding: "5px" }}
              >
                TOTAL BILL AMOUNT
              </td>
              <td style={{ border: "1px solid black", padding: "5px" }}></td>
              <td style={{ border: "1px solid black", padding: "5px" }}></td>
              <td style={{ border: "1px solid black", padding: "5px" }}></td>
              <td style={{ border: "1px solid black", padding: "5px" }}>
                {new Intl.NumberFormat("en-IN").format(totalDispatchWeight)}
              </td>
            </tr>
            <tr>
              <td
                colSpan={8}
                style={{ border: "1px solid black", padding: "5px" }}
              >
                ROUNDED OFF +/-
              </td>
              <td
                colSpan={2}
                style={{ border: "1px solid black", padding: "5px" }}
              >
                ₹{formattedTotal}
              </td>
            </tr>
            <tr>
              <td
                colSpan={8}
                style={{ border: "1px solid black", padding: "5px" }}
              >
                GRAND TOTAL
              </td>
              <td
                colSpan={2}
                style={{
                  border: "1px solid black",
                  padding: "5px",
                  backgroundColor: "yellow",
                }}
              >
                ₹{formattedTotal}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ marginTop: "10px" }}>
          Amount In Words Rs.:- {totalAmountInWords}
          <span style={{ backgroundColor: "yellow" }}></span>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "50%", verticalAlign: "top" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <th
                        colSpan={2}
                        style={{
                          border: "1px solid black",
                          padding: "5px",
                          textAlign: "left",
                        }}
                      >
                        Bank Detail
                      </th>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        Name
                      </td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        :- GN CARGO TRANSWAYS
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        Account No.
                      </td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        :- 35731706196
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        Ifsc Code
                      </td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        :- SBIN0012901
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        Branch
                      </td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>
                        {/* {challanData[0].branch_name ? challanData[0].branch_name : ''} */}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td
                style={{
                  width: "50%",
                  textAlign: "center",
                  verticalAlign: "bottom",
                  padding: "20px",
                }}
              >
                FOR : GN CARGO TRANSWAYS
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                Authorised Signatory
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentDepositPDF;
